// src/pages/Wishlist.js
import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Box, CircularProgress, Tooltip } from '@mui/material';
import { StyledButton } from '../components/StyledComponents';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { getWishlist } from '../services/api';
import ListingCard from '../components/ListingCard';

const StyledContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
}));

function Wishlist() {
    const [wishlistedItems, setWishlistedItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchWishlist();
    }, []);

    const fetchWishlist = async () => {
        try {
            const response = await getWishlist(true); // true to get full listing details
            setWishlistedItems(response.data);
        } catch (error) {
            console.error('Error fetching wishlist:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleWishlistUpdate = (listingId, isWishlisted) => {
        if (!isWishlisted) {
            setWishlistedItems(items => items.filter(item => item.listing_id !== listingId));
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <StyledContainer maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom>
                My Wishlist
            </Typography>
            <Tooltip title="Manage your wanted board to get alerts for new listings in your favorite categories">
                <StyledButton
                    variant="outlined"
                    component={RouterLink}
                    to="/wanted-board"
                    sx={{ mb: 3 }}
                >
                    Manage Wanted Board
                </StyledButton>
            </Tooltip>
            <Grid container spacing={3}>
                {wishlistedItems.map((item) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={item.listing_id}>
                        <ListingCard
                            listing={item.listing}
                            isWishlisted={true}
                            onWishlistUpdate={handleWishlistUpdate}
                        />
                    </Grid>
                ))}
                {wishlistedItems.length === 0 && (
                    <Grid item xs={12}>
                        <Typography variant="body1" align="center" color="textSecondary">
                            No items in your wishlist yet
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </StyledContainer>
    );
}

export default Wishlist;